/**
 * CMS Medicare Beneficiary Identifier (MBI).
 * Positions: 1 C, 2 A, 3 AN, 4 N, 5 A, 6 AN, 7 N, 8 A, 9 A, 10 N, 11 N.
 * Letters exclude S, L, O, I, B, and Z. Dashes are not part of the value.
 */
const MEDICARE_MBI_PATTERN =
  /^[1-9][AC-HJ-KMNP-RT-Y][AC-HJ-KMNP-RT-Y0-9][0-9][AC-HJ-KMNP-RT-Y][AC-HJ-KMNP-RT-Y0-9][0-9][AC-HJ-KMNP-RT-Y][AC-HJ-KMNP-RT-Y][0-9][0-9]$/i;

export const INVALID_MBI_MESSAGE =
  "Invalid MBI format. Please verify the Medicare number on the patient's Medicare card.";

export const isValidMedicareMbi = (value: unknown): boolean => {
  if (value == null) return false;
  return MEDICARE_MBI_PATTERN.test(String(value).trim());
};

/** Policy # rule used when the insurance category is Medicare. */
export const validateMedicarePolicyNumber = (value: unknown): true | string => {
  if (value == null || String(value).trim() === "") {
    return "Policy # is required.";
  }
  return isValidMedicareMbi(value) ? true : INVALID_MBI_MESSAGE;
};
